export default "__VITE_PUBLIC_ASSET__5b69654b__"